export const ArrayTotalizarByProp = (miArray, prop) => {
    var total = 0;
    miArray.forEach((item) => {
      total += Number(item[prop]);
    });
    return total;
  };